import React, { useState, useEffect } from "react";
import s from "../../admin_styles/UserSearch.module.css";
import UserFullInfoModal from "./UserFullInfoModal"; // импортируем наш компонент модалки

export default function UsersPayments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeUserId, setActiveUserId] = useState(null);

  const fetchPayments = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/admin/get_all_payments", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({})
      });

      const result = await res.json();
      setPayments(result.payments || []);
    } catch (err) {
      console.error("Ошибка загрузки платежей:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  if (loading) {
    return <p>Загрузка...</p>;
  }

  return (
    <div className={s.tableWrapper}>
      {payments.length === 0 ? (
        <p>Нет платежей</p>
      ) : (
        <table className={s.table}>
          <thead>
            <tr>
              <th>ID</th>
              <th>User ID</th>
              <th>Логин</th>
              <th>Имя</th>
              <th>Сумма</th>
              <th>Описание</th>
              <th>Дата</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p.id} onClick={() => setActiveUserId(p.user_id)} style={{ cursor: "pointer" }}>
                <td>{p.id}</td>
                <td>{p.user_id}</td>
                <td>{p.user_login}</td>
                <td>{p.user_name}</td>
                <td>{p.amount}</td>
                <td>{p.description}</td>
                <td>
                  {p.created_at
                    ? (() => {
                        const [date, time] = p.created_at.split("T");
                        const [y, m, d] = date.split("-");
                        const shortTime = time.slice(0, 5);
                        return `${d}.${m}.${y} ${shortTime}`;
                      })()
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Модалка с инфой по пользователю */}
      {activeUserId && (
        <UserFullInfoModal
          userId={activeUserId}
          onClose={() => setActiveUserId(null)}
        />
      )}
    </div>
  );
}
